import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'

class Thumbnails extends React.Component {
  constructor() {
    super()

    this.state = {
      selected: false,
    }

    this.onImageClick = this.onImageClick.bind(this)
    this.unselectThumbnail = this.unselectThumbnail.bind(this)
  }

  componentDidMount() {
    App.events.subscribe('app:thumbnail:unselect', this.unselectThumbnail)
  }

  unselectThumbnail() {
    if (this.refs.thumbnail) this.setState({ selected: false })
  }

  onImageClick() {
    this.setState({ selected: !this.state.selected })

    this.props.onCheckboxChange(this.props.image, !this.state.selected)
  }

  render() {
    const imgSelected = this.state.selected ? 'is-selected' : ''

    return (
      <div className="uploaded-images__container" ref="thumbnail">
        <div className={`uploaded-images__image-container is-active ${imgSelected}`} onClick={this.onImageClick}>
          <div className="uploaded-images__image-holder">
            <img src={this.props.image.image_name.small.url} alt={this.props.image.image_name.url} />
            <div className="uploaded-images__select">
              <input
                type="checkbox"
                id={`image-${this.props.image.id}`}
                className="checkbox"
                checked={this.state.selected}
              />
              <label htmlFor={`image-${this.props.image.id}`} />
            </div>
            {this.props.id === this.props.mainImageId
              && (
              <div className="uploaded-images__set-thumb">
                <Icon type={['far', 'image']} color="green-dark" />
              </div>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

Thumbnails.propTypes = {
  id: PropTypes.number.isRequired,
  image: PropTypes.object.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  mainImageId: PropTypes.number.isRequired,
}

export default Thumbnails
